const PLAN_DEVELOPPEMENT_IMAGE_BY_KEYWORD = [
    {
        keywords: ["leadership", "management"],
        image: "https://images.unsplash.com/photo-1552664730-d307ca884978",
    },
    {
        keywords: ["projet", "project", "organisation"],
        image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40",
    },
    {
        keywords: ["communication", "soft skills", "collaboration"],
        image: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d",
    },
    {
        keywords: ["temps", "priorite", "efficacite"],
        image: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3",
    },
];

const DEFAULT_PLAN_DEVELOPPEMENT_IMAGE = PLAN_DEVELOPPEMENT_IMAGE_BY_KEYWORD[0].image;

export const staticPlanCards = [
    {
        id: "leadership-management",
        titre: "Leadership et Management",
        nom: "Leadership et Management",
        category: "Management",
        description: "Developpez vos pratiques de leadership, d'accompagnement et de pilotage d'equipe.",
        duration: "2 jour(s)",
        level: "Intermediaire",
        source: "PLAN_DEVELOPPEMENT",
        disabled: false,
        buttonLabel: "Demander",
        helper: "",
    },
    {
        id: "gestion-temps",
        titre: "Gestion du temps",
        nom: "Gestion du temps",
        category: "Management",
        description: "Ameliorez votre organisation, la gestion de vos priorites et votre efficacite au quotidien.",
        duration: "2 jour(s)",
        level: "Intermediaire",
        source: "PLAN_DEVELOPPEMENT",
        disabled: false,
        buttonLabel: "Demander",
        helper: "",
    },
    {
        id: "gestion-projet",
        titre: "Gestion de projet",
        nom: "Gestion de projet",
        category: "Organisation",
        description: "Structurez les priorites, les livrables et le suivi des actions avec une methode claire.",
        duration: "3 jour(s)",
        level: "Tous niveaux",
        source: "PLAN_DEVELOPPEMENT",
        disabled: false,
        buttonLabel: "Demander",
        helper: "",
    },
    {
        id: "communication-efficace",
        titre: "Communication efficace",
        nom: "Communication efficace",
        category: "Soft skills",
        description: "Renforcez la qualite des echanges, la clarte des messages et la collaboration.",
        duration: "1 jour(s)",
        level: "Debutant",
        source: "PLAN_DEVELOPPEMENT",
        disabled: false,
        buttonLabel: "Demander",
        helper: "",
    },
].map((card) => ({
    ...card,
    image: resolvePlanDeveloppementImage(card),
    badge: "Formation",
}));

export function normalizeFormationForRequest(formation) {
    return {
        id: formation.id,
        formationId: formation.formationId || formation.id,
        titre: formation.titre || formation.nom || formation.title,
        nom: formation.nom || formation.titre || formation.title,
        description: formation.description || "",
        categorie: formation.categorie || formation.category || formation.domaine || "",
        duree: formation.duree || formation.duration || "",
        source: formation.source || "PLAN_DEVELOPPEMENT",
    };
}

export function buildFormationCardFromItem(item) {
    const title = item.formationNom || item.competenceNom || item.skillNom || "Formation";

    return {
        id: item.id,
        titre: title,
        nom: title,
        formation: item.formationId
            ? {
                id: item.formationId,
                nom: title,
            }
            : null,
        category: item.formationReference || item.type || "Plan de developpement",
        description: item.recommendationReason || item.commentaire || "Action ajoutee au plan.",
        duration: null,
        level: item.gap != null ? `Gap ${item.gap}` : null,
        status: item.status || null,
        source: "PLAN_DEVELOPPEMENT",
        disabled: !!item.demandeId,
        buttonLabel: item.demandeId ? "Deja demandee" : "Demander",
        helper: item.demandeId ? "Une demande est deja associee a cet element." : null,
        itemId: item.id,
        image: resolvePlanDeveloppementImage({
            title,
            category: item.formationReference || item.type,
            image: item.imageUrl || item.image,
        }),
        badge: "Formation",
    };
}

export function resolvePlanDeveloppementImage(card) {
    if (card?.image) {
        return card.image;
    }

    const content = `${card?.titre || card?.nom || card?.title || ""} ${card?.category || card?.categorie || ""}`.toLowerCase();
    const match = PLAN_DEVELOPPEMENT_IMAGE_BY_KEYWORD.find((entry) =>
        entry.keywords.some((keyword) => content.includes(keyword))
    );

    return match?.image || DEFAULT_PLAN_DEVELOPPEMENT_IMAGE;
}
